/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderStatusDtoCreate } from '../../models/order-status-dto-create';
import { OrderStatusItem } from '../../models/order-status-item';

export interface OrderStatusControllerCreate$Params {
      body: OrderStatusDtoCreate
}

export function orderStatusControllerCreate(http: HttpClient, rootUrl: string, params: OrderStatusControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderStatusItem;
}>> {
  const rb = new RequestBuilder(rootUrl, orderStatusControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderStatusItem;
      }>;
    })
  );
}

orderStatusControllerCreate.PATH = '/order/status';
